import { render, staticRenderFns } from "./wrong-info.vue?vue&type=template&id=5ae42aec&scoped=true&"
import script from "./wrong-info.vue?vue&type=script&lang=js&"
export * from "./wrong-info.vue?vue&type=script&lang=js&"
import style0 from "./wrong-info.vue?vue&type=style&index=0&id=5ae42aec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae42aec",
  null
  
)

export default component.exports